import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["content", "customImage"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { memo, useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { createUseStyles, useTheme, Icon, Modal, Text } from 'hoi-poi-ui';
import Illustrations from "./components/Illustrations";
import styles from "./styles/ModalContactRequest";
const {
  ContactRequest
} = Illustrations;
const useStyles = createUseStyles(styles, 'ModalContactRequest');
const ModalContactRequest = /*#__PURE__*/memo(_ref => {
  let {
      content,
      customImage
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const classes = useStyles();
  const theme = useTheme();
  const modalProps = useMemo(() => {
    return _objectSpread({
      size: 'small',
      useAutoHeight: false
    }, props);
  }, [props]);
  const Img = useMemo(() => customImage || ContactRequest, [customImage]);
  const renderList = useCallback((content, key) => /*#__PURE__*/React.createElement("ol", {
    className: classes.list,
    key: key
  }, content.map((item, index) => /*#__PURE__*/React.createElement("li", {
    className: classNames(classes.listItem, {
      [classes.listItemActive]: item.active
    }),
    key: `${key}-${index}`
  }, item.active ? /*#__PURE__*/React.createElement(Icon, {
    color: theme.colors.semantic.positive500,
    name: "taskChecked",
    size: "large",
    className: classes.bullet
  }) : /*#__PURE__*/React.createElement(Text, {
    color: theme.colors.textLight.secondary,
    className: classNames(classes.bullet, classes.bulletNumber)
  }, index + 1), /*#__PURE__*/React.createElement(Text, {
    color: item.active ? theme.colors.textLight.primary : theme.colors.textLight.secondary
  }, item.text)))), [classes.bullet, classes.bulletNumber, classes.list, classes.listItem, classes.listItemActive, theme]);
  const renderContent = useMemo(() => {
    return content.reduce((arr, item, index) => {
      let newContent;
      switch (item.type) {
        case 'text':
          newContent = /*#__PURE__*/React.createElement(Text, {
            key: index
          }, item.content);
          break;
        case 'list':
          if (!item.content.length) return arr;
          newContent = renderList(item.content, index);
          break;
        default:
          return arr;
      }
      return [...arr, newContent];
    }, []);
  }, [content, renderList]);
  return /*#__PURE__*/React.createElement(Modal, modalProps, /*#__PURE__*/React.createElement("figure", {
    className: classes.figure
  }, /*#__PURE__*/React.createElement(Img, null)), renderContent && /*#__PURE__*/React.createElement("div", {
    className: classes.content
  }, renderContent));
});
process.env.NODE_ENV !== "production" ? ModalContactRequest.propTypes = {
  content: PropTypes.arrayOf(PropTypes.shape({
    type: PropTypes.oneOf(['list', 'text']),
    content: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.shape({
      text: PropTypes.string,
      active: PropTypes.bool
    }))])
  })),
  customImage: PropTypes.node,
  videoSrc: PropTypes.string,
  isOpen: PropTypes.bool,
  title: PropTypes.string,
  confirmText: PropTypes.string,
  onConfirm: PropTypes.func
} : void 0;
export default ModalContactRequest;